import { render } from "./HomeModule.vue?vue&type=template&id=5e9f3f89&scoped=true"
import script from "./HomeModule.vue?vue&type=script&lang=js"
export * from "./HomeModule.vue?vue&type=script&lang=js"

import "./HomeModule.vue?vue&type=style&index=0&id=5e9f3f89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9f3f89"]])

export default __exports__